import { WidgetCheckbox, WidgetRadio, WidgetSelect } from 'jamespot-user-api';

export function widgetToOptions(widget: WidgetSelect | WidgetCheckbox | WidgetRadio): Array<WidgetOption> {
    return Object.entries(widget.options).map(([k, v]) => ({
        label: v,
        value: k,
    }));
}

export type WidgetOption = {
    label: string;
    value: string | number;
};
